<template>
  <h6 class="mb-0 titulo-mobile font-weight-bold d-flex justify-content-between align-items-center">
    <span>{{ titulo }}</span>
    <b-dropdown v-if="isMultiplosBotoes" class="m-1" :class="breakpointNone" right no-caret>
      <template #button-content>
        <font-awesome-icon icon="bars" />
      </template>
      <b-dropdown-item v-for="btn in botoesList" :key="btn.id" @click="clickMe(btn)" :disabled="btn.disabled">
        <font-awesome-icon :icon="btn.icone" class="mr-2" />
        {{ btn.texto }}
      </b-dropdown-item>
    </b-dropdown>
    <div v-if="isMultiplosBotoes" class="d-none" :class="breakpointBlock">
      <b-button v-for="btn in botoesList" :key="btn.id" size="sm" class="m-1" @click="clickMe(btn)"
        :type="btn.type || 'button'" :disabled="btn.disabled" :variant="btn.variant">
        <font-awesome-icon :icon="btn.icone" class="mr-3" />
        {{ btn.texto }}
      </b-button>
    </div>
    <b-button v-if="isUmBotao" size="sm" @click="clickMe(botoesList[0])" :disabled="botoesList[0].disabled"
      :type="botoesList[0].type || 'button'" v-b-tooltip.hover :title="botoesList[0].texto">
      <font-awesome-icon :icon="botoesList[0].icone" />
      <span class="d-none ml-3" :class="breakpointInline">{{ botoesList[0].texto }}</span>
    </b-button>
    <div v-if="!isUmBotao && !isMultiplosBotoes"
      class="custom-content d-flex flex-column-reverse flex-lg-row justify-content-between align-items-center mr-3">
      <slot name="customContent"></slot>
    </div>
  </h6>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { BotaoSagres } from "@/types/botao-sagres";

const CompProps = Vue.extend({
  name: "HeaderSagres",
  props: {
    titulo: {
      type: String,
      required: true,
    },
    botoes: {
      type: Array as () => BotaoSagres[],
      default: () => [],
    },
    breakpoint: {
      type: String,
      default: "md",
    },
    voltar: {
      type: Boolean,
      default: false,
    },
  },
});
@Component
export default class HeaderSagres extends mixins(CompProps) {
  get breakpointNone(): string {
    return `d-${this.breakpoint}-none`
  }
  get breakpointBlock(): string {
    return `d-${this.breakpoint}-block`
  }
  get breakpointInline(): string {
    return `d-${this.breakpoint}-inline`
  }
  get isMultiplosBotoes(): boolean {
    return this.botoesList.length > 1
  }
  get isUmBotao(): boolean {
    return this.botoesList.length === 1
  }
  get botoesList(): BotaoSagres[] {
    if (this.voltar) return [...this.botoes, { id: -1, icone: 'arrow-left', texto: 'Voltar' }]
    return this.botoes
  }

  clickMe(botao: BotaoSagres): void {
    if (botao.id === -1) this.$router.back();
    if (botao.acao) botao.acao();
    if (botao.url) this.$router.push(botao.url);
  }
}
</script>
